import arrayToQueryString from '../../utils/arrayToQueryString';
import { httpClient, httpClientHeader } from '../../services/httpClient';

import { IAnnouncementItem } from '../../types';

const API_URL = '/_api/wix-new-releases-service/v1/announcements';

export const fetchFeed = async ({
  metaSiteInstance,
  subjectNames,
  language,
}: {
  metaSiteInstance: string;
  subjectNames: string[];
  language?: string;
}): Promise<IAnnouncementItem[]> => {
  const subjectNamesQuery = arrayToQueryString('subjectNames', subjectNames);
  const headers = {
    Authorization: metaSiteInstance,
    wixLanguage: language,
    ...httpClientHeader,
  };

  return httpClient
    .get(`${API_URL}?paging.limit=10&${subjectNamesQuery}`, {
      headers,
    })
    .then((response) => response.data)
    .then(({ announcements }) => announcements)
    .catch((e) => {
      throw new Error(`Failed to fetch new releases with error: ${e}`);
    });
};
